// Theming por rol (visionOS): mismo lenguaje visual, distinto acento + wallpaper.
import type { AuthUser } from "@/lib/auth-store";

export type AppRole = "student" | "teacher" | "admin";

export interface RoleTheme {
  role: AppRole;
  roleClass: string; // .role-student | .role-teacher | .role-admin (setea --role-accent en CSS)
  accent: string;
  accentTo: string;
  wallpaper: "aurora" | "forest" | "ocean";
  label: string;
}

const THEMES: Record<AppRole, RoleTheme> = {
  student: { role: "student", roleClass: "role-student", accent: "#6366F1", accentTo: "#8B5CF6", wallpaper: "aurora", label: "Alumno" },
  teacher: { role: "teacher", roleClass: "role-teacher", accent: "#10B981", accentTo: "#0D9488", wallpaper: "forest", label: "Docente" },
  admin:   { role: "admin",   roleClass: "role-admin",   accent: "#2563EB", accentTo: "#334155", wallpaper: "ocean",  label: "Gestión" },
};

export function roleOf(user: AuthUser | null): AppRole {
  if (user?.role === "teacher") return "teacher";
  if (user?.role === "institution_admin" || user?.role === "platform_admin") return "admin";
  return "student";
}

export function themeFor(user: AuthUser | null): RoleTheme {
  return THEMES[roleOf(user)];
}
